import React, { Fragment } from 'react';
import { Divider } from '@lightspeed/flame/Divider';
import Text from '@lightspeed/cirrus-text';

const FormHeader = ({ title, description }) => (
  <Fragment>
    <header className="cr-bg-snow-100 cr-ph-4 cr-pv-2">
      <Text className="cr-text cr-night cr-bold">{title}</Text>
      <Text className="cr-text cr-night">{description}</Text>
    </header>
    <Divider />
  </Fragment>
);

export default FormHeader;
